import { render } from "./AddNewGroupToPortfolio.vue?vue&type=template&id=4ab70710&ts=true"
import script from "./AddNewGroupToPortfolio.vue?vue&type=script&lang=ts"
export * from "./AddNewGroupToPortfolio.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__